/**
 * 🔐 Session Storage Helper
 * Maneja el almacenamiento de tokens de forma compatible con multi-sesión
 * 
 * - Sesión principal: usa localStorage (persiste)
 * - Sesiones aisladas: usa sessionStorage (temporal)
 */

// Guardar referencias ORIGINALES antes de cualquier modificación
const _originalLocalStorageGetItem = Storage.prototype.getItem;
const _originalLocalStorageSetItem = Storage.prototype.setItem;
const _originalLocalStorageRemoveItem = Storage.prototype.removeItem;

// Detectar si es sesión aislada
export const isIsolatedSession = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('isolated') === 'true' || 
           _originalLocalStorageGetItem.call(sessionStorage, 'isolatedSession') === 'true';
};

// Obtener key de token única por sesión
export const getTokenKey = () => {
    const sessionId = _originalLocalStorageGetItem.call(sessionStorage, 'sessionId');
    return sessionId ? `token_${sessionId}` : 'token';
};

// Obtener el storage correcto según tipo de sesión
export const getStorage = () => isIsolatedSession() ? sessionStorage : localStorage;

/**
 * Obtener el token de autenticación (usando métodos originales)
 */
export const getAuthToken = () => {
    const storage = isIsolatedSession() ? sessionStorage : localStorage;
    return _originalLocalStorageGetItem.call(storage, getTokenKey());
};

/**
 * Guardar el token de autenticación (usando métodos originales)
 */
export const setAuthToken = (token) => {
    const storage = isIsolatedSession() ? sessionStorage : localStorage;
    _originalLocalStorageSetItem.call(storage, getTokenKey(), token);
};

/**
 * Eliminar el token de autenticación (usando métodos originales)
 */
export const removeAuthToken = () => {
    const storage = isIsolatedSession() ? sessionStorage : localStorage;
    _originalLocalStorageRemoveItem.call(storage, getTokenKey());
};

// Interceptar SOLO localStorage para redirigir 'token' al storage correcto
const originalGetItem = _originalLocalStorageGetItem.bind(localStorage);
const originalSetItem = _originalLocalStorageSetItem.bind(localStorage);
const originalRemoveItem = _originalLocalStorageRemoveItem.bind(localStorage);

localStorage.getItem = function(key) {
    if (key === 'token') {
        return getAuthToken();
    }
    return originalGetItem(key);
};

localStorage.setItem = function(key, value) {
    if (key === 'token') {
        setAuthToken(value);
        return;
    }
    return originalSetItem(key, value);
};

localStorage.removeItem = function(key) {
    if (key === 'token') {
        removeAuthToken();
        return;
    }
    return originalRemoveItem(key);
};

console.log('🔐 Session storage helper inicializado', isIsolatedSession() ? '(sesión aislada)' : '(sesión principal)');
